import ExplainerText from "components/elements/ExplainerText";
import { translate } from "utils/Translate";
import { priceConvertor } from "utils/general";
import { AppContext } from "contexts/AppContext";
import { useContext } from "react";
import { Box } from "@mui/material";

export function BasketPrintCard({ sellingPrice, printTitle, printText }) {
  const {brandData, styleGuide} = useContext(AppContext);
  const pointSuffix = translate("_POINTS_SHORT_", "pt");
  const dkkSuffix = translate("_DKK_", "kr");
  const printTextLines = printText?.split('\n') || [];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, border: `1px solid ${styleGuide.color4}`, padding: 1, marginTop: 1, borderRadius: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <ExplainerText
          style={{ color: styleGuide.color5 }}
        >
          {translate("_BASKET_PRINTS_ADDED_LABEL_", "Tryk")}:
        </ExplainerText>

        {sellingPrice?.amount > 0 &&
          <ExplainerText
            style={{ color: styleGuide.color16 }}
          >
            {`${priceConvertor(
              brandData,
              sellingPrice.amount,
              sellingPrice.type === 'POINTS' ? pointSuffix : dkkSuffix
            )}`}
          </ExplainerText>
        }
      </Box>
      <ExplainerText
        style={{ color: styleGuide.color5 }}
      >
        {printTitle}
      </ExplainerText>
      {printTextLines.map((line, idx) => (
        <ExplainerText
          key={idx}
          style={{ color: styleGuide.color5 }}
        >
          {line}
        </ExplainerText>
      ))}
    </Box>
  )
}